import { Grid } from '@mui/material';
import { PrimaryButton } from '../../theme/index'
import '../../sass/styles.scss';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch } from 'react-redux';
import { modalDeleteAction } from '../../redux/reducers/Modal';

const Product = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();

  return (
    <>
        <Grid item xs={ 10 }>
          {
            ( screenWidth > 500 ) ?
              <h5 style={{ margin: '0', marginBottom: '2rem' }}>Producto / eliminar</h5>
            :
              <h6 style={{ margin: '0', marginBottom: '2rem' }}>Producto / eliminar</h6>
          }
        </Grid>
        <Grid item xs={ 12 }textAlign='center'>
          {
            ( screenWidth > 500 ) ?
              <h3>Esta seguro que desea eliminar este producto?</h3>
            :
              <h6>Esta seguro que desea eliminar este producto?</h6>
          }
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='center' className='pr-2'>
            <PrimaryButton onClick={ () => dispatch(modalDeleteAction()) } sx={{ width: '50%', boxShadow: 5 }}>Eliminar</PrimaryButton>
        </Grid>
    </>
  )
}

export default Product